import UserRegistered from '../../models/reports/usersRegistered.model'

let storeContent = utils.generateStore({
   UserRegistered,
   users: [],
   selectedCustomerData: {},
})

export default {
   state: {
      ...storeContent.state
   },
   getters: {
      ...storeContent.getters
   },
   mutations: {
      ...storeContent.mutations
   },
   actions: {
      async verifyPayment(ctx, payload) {
         try {
            ctx.commit('loading', true)
            let data = payload.ref.formData_

            if (await payload.ref.isValid()) {
               await api.fetchEndpointSecure({
                  resource: "registration",
                  action: "update:payment_verified",
                  data: {
                     customer_id: ctx.getters.selectedCustomerData._id,
                     transaction_id: data.transaction_id,
                     amount: data.amount,
                     payment_option: data?.payment_option?._id,
                  },
                  meta_data: {}
               })

               $notify('success', 'Payment Verified', `Payment for customer ${ctx.getters.selectedCustomerData.name} successfully verified.`)
               ctx.commit('show',false)
            }

            ctx.commit('loading', false)
         } catch (err) {
            ctx.commit('loading', false)
            throw err
         }
      },
      async fetchUserRegFormData(ctx) {
         try {
            // Fetch UserRegistered Groups
            let res = await api.fetchEndpointSecure({
               resource: "registration",
               action: "get:payment_options",
               data: {},
               meta_data: {}
            })

            console.log('Getter',ctx.getters)
            let form = utils.appendSelectData({
               form: UserRegistered.forms.payment_verification,
               model: 'payment_option',
               label: 'name',
               data: res.result.options
            })
            console.log(form)

            if (form) {
               let Model = ctx.getters.UserRegistered
               Model.forms.payment_verification = form
               ctx.commit('UserRegistered', Model)
            }
         } catch (err) {
            throw err
         }
      },
      async queryUsersRegistered(ctx,payload) {
         try {
            ctx.commit('loading', true)
            let data = payload.ref.formData_
            
            if (await payload.ref.isValid()) {
               let from = moment(`${data.duration[0]} 00:00`, 'DD-MM-YYYY HH:mm').valueOf(), to = moment(`${data.duration[1]} 23:59`, 'DD-MM-YYYY HH:mm').valueOf();
               
               let res = await api.fetchEndpointSecure({
                  resource: "customer",
                  action: "fetch:customersRegistered",
                  data: {
                     status: data.status,
                     from,
                     to,
                  },
                  meta_data: {}
               })
               ctx.commit('users', res.result.customers)
            }

            ctx.commit('loading', false)
         } catch (err) {
            ctx.commit('loading', false)
            throw err
         }
      }
   }
};